export default __webpack_public_path__ + "static/media/imageSeven.b2a58b4d.png";